import {RepoBuildDisplay} from './RepoBuildDisplay.js';
import {LastRepos} from '../components/LastRepos.js';

import React, {Component} from 'react';

export class GlobalView extends Component {
  constructor(props) {
    super(props);
    this.state = { buildId: null };
    this.onBuildEvent = this.onBuildEvent.bind(this);
  }

  onBuildEvent(buildNr) {
    this.setState({buildId: buildNr});
  }

  render() {
    return (
      <div className="row">
        <div className="col-md-9 col-md-push-3">
          <RepoBuildDisplay buildId={this.state.buildId} />
        </div>
        <div className="col-md-3 col-md-pull-9">
          <LastRepos onBuildEvent={this.onBuildEvent}/>
        </div>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/views/GlobalView.js